function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import Paper from "@pixel/core/Paper";
import { useTheme } from "@pixel/core/styles";
/** A base-level React component used as a wrapper for any component that requires padding.
 * Provides top, bottom, left, right padding
 * Directional padding cam be added/removed
 * Provides an option for background, either transparent or default
 * Todo: testing, test Padding props etc
 */
const LayoutRootSection = _ref => {
  let {
    top = false,
    left = true,
    right = true,
    bottom = false,
    divideBottom = false,
    divideTop = false,
    transparent = false,
    flexHeight = false,
    children,
    ...rest
  } = _ref;
  const theme = useTheme();
  const spacingValue = {
    normal: 2,
    small: 1,
    xsmall: 0.5
  };
  const sxStyles = {
    display: flexHeight ? "flex" : "block",
    overflow: flexHeight ? "scroll" : undefined,
    flex: flexHeight ? 1 : 0,
    width: "100%",
    paddingTop: top === true ? theme.spacing(spacingValue.normal) : 0,
    paddingLeft: left === true ? theme.spacing(spacingValue.normal) : 0,
    paddingRight: right === true ? theme.spacing(spacingValue.normal) : 0,
    paddingBottom: bottom === true ? theme.spacing(spacingValue.normal) : 0,
    background: transparent ? "transparent" : theme.palette.background.paper,
    borderBottom: divideBottom === true ? "solid 1px " + theme.palette.pixelContrast.fades.softer : "none",
    borderTop: divideTop === true ? "solid 1px " + theme.palette.pixelContrast.fades.softer : "none",
    [theme.breakpoints.down("sm")]: {
      paddingTop: top === true ? theme.spacing(spacingValue.small) : 0,
      paddingLeft: left === true ? theme.spacing(spacingValue.small) : 0,
      paddingRight: right === true ? theme.spacing(spacingValue.small) : 0,
      paddingBottom: bottom === true ? theme.spacing(spacingValue.small) : 0
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: top === true ? theme.spacing(spacingValue.xsmall) : 0,
      paddingLeft: left === true ? theme.spacing(spacingValue.xsmall) : 0,
      paddingRight: right === true ? theme.spacing(spacingValue.xsmall) : 0,
      paddingBottom: bottom === true ? theme.spacing(spacingValue.xsmall) : 0
    }
  };
  return /*#__PURE__*/React.createElement(Paper, _extends({
    elevation: 0
  }, rest, {
    sx: sxStyles
  }), children);
};
export default LayoutRootSection;